module.exports = {
          srcSet: __webpack_public_path__ + "/assets/48cc49213b3533ecfcf860278d2692a9-320.jpg"+" 320w"+","+__webpack_public_path__ + "/assets/375ddda72bf7386a945dcd83b05044c2-400.jpg"+" 400w",
          images:[ {path: __webpack_public_path__ + "/assets/48cc49213b3533ecfcf860278d2692a9-320.jpg",width: 320,height: 320},{path: __webpack_public_path__ + "/assets/375ddda72bf7386a945dcd83b05044c2-400.jpg",width: 400,height: 400}],
          src: __webpack_public_path__ + "/assets/48cc49213b3533ecfcf860278d2692a9-320.jpg",
          toString:function(){return __webpack_public_path__ + "/assets/48cc49213b3533ecfcf860278d2692a9-320.jpg"},
          
          width: 320,
          height: 320
        }